import { reflectKeys } from "@/utils/key.reflactor";

export const CREDENTIAL_CHECK_MAX_WAIT = 600000; // 10 minutes

export const FILE_FETCH_INTERVAL = [
  1000, 2000, 3000, 5000, 8000, 13000, 21000, 36000, 57000, 93000,
];
export const FILE_DEFAULT_FETCH_INTERVAL = 120000;

export const PICKER_ERROR = {
  EMPTY_EMAIL: "email.is.empty",
  REFRESH_TOKEN_EXPIRED: "refresh.token.expired",
};

export const FILE_TYPE = {
  DOCUMENT: {
    NAME: "DOCUMENT",
    VALUE: "application/vnd.google-apps.document",
  },
  SPREADSHEET: {
    NAME: "SPREADSHEET",
    VALUE: "application/vnd.google-apps.spreadsheet",
  },
  PRESENTATION: {
    NAME: "PRESENTATION",
    VALUE: "application/vnd.google-apps.presentation",
  },
  MSWORD: {
    NAME: "MSWORD",
    VALUE: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  },
  MSEXCEL: {
    NAME: "MSEXCEL",
    VALUE: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  },
  MSPPT: {
    NAME: "MSPPT",
    VALUE: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  },
  COLABORATORY: {
    NAME: "COLABORATORY",
    VALUE: "application/vnd.google.colaboratory",
  },
  PDF: {
    NAME: "PDF",
    VALUE: "application/pdf",
  },
  OTHERS: {
    NAME: "OTHERS",
    VALUE: "",
  },
};

export const CONFIG = { ADD: "add", EMBED: "embed", LIMIT_FILE_TYPE: "limit_file_type" };
export const CONTEXT = { LESSON: "lesson", ATTEMPT: "attempt", NOTEBOOK: "notebook" };
export const FILE_PROCESSING_STATE = reflectKeys(["ERROR", "READY", "PROCESSING"]);

export const TYPE_CONTEXT = {
  TEXT_MEDIA: "text/media",
  FRQ: "frq",
  TEACHER_FEEDBACK: "teacher_feedback",
};

export const ALLOWED_MIMETYPES =
  "application/vnd.google-apps.presentation,application/vnd.google-apps.spreadsheet,application/vnd.google-apps.document,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.presentationml.presentation";

export const ATTEMPT_ALLOWED_MIMETYPES =
  "application/vnd.google-apps.presentation,application/vnd.google-apps.spreadsheet,application/vnd.google-apps.document,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.google.colaboratory,application/pdf";

export const MIMETYPE_PREFIX = "application/vnd.google-apps.";

export const ICON_MAP = {
  DOCUMENT: "Doc32",
  SPREADSHEET: "Sheet32",
  PRESENTATION: "Slide32",
  MSWORD: "Word32",
  MSEXCEL: "Excel32",
  MSPPT: "Ppt32",
  COLABORATORY: "Colab32",
  OTHERS: "Google32",
  PDF: "Pdf32",
};

export const TITLE_SUFFIX = {
  marked: "(Marked)",
  edited: "(Edited)",
};

export const ERROR_CODE = {
  INSUFFICIENT_PERMISSION_GRANTED: "INSUFFICIENT_PERMISSION_GRANTED",
};

export const EVENT_ACTION = {
  OPEN_IN_NEW_TAB: "OPEN_IN_NEW_TAB",
  DOWNLOAD: "DOWNLOAD",
  MARK_AS_GOOGLE_FILE: "MARK_AS_GOOGLE_FILE",
  MARK_AS_PDF: "MARK_AS_PDF",
  REMOVE: "REMOVE",
  OPEN_ADD_FROM_GOOGLE: "OPEN_ADD_FROM_GOOGLE",
  OPEN_EMBED_FROM_GOOGLE: "OPEN_EMBED_FROM_GOOGLE",
};

export const CURRENT_USER_GOOGLE_CREDENTIALS_COOKIE = "_sls_g_XGWEAF";

export const DOC_USAGE = {
  MARKING: "marking",
  EDITING: "editing",
};

export const ATTEMPT_GOOGLE_DOCUMENT_RESOURCE_TYPE = {
  QUESTION_ATTEMPT: "QUESTION_ATTEMPT",
  ATTEMPT_HISTORY: "ATTEMPT_HISTORY",
};

export const USER_CREDENTIAL_REQUEST_CONTEXT = {
  ACCOUNT_LINKING: "account_linking",
  API_ACCESS: "api_access",
} as const;
